class GaEvents {
    constructor() {
        this.triggerClass = '.gaevent';

        if (document.querySelector(this.triggerClass)) {
            this.initEvents();
        }
    }

    initEvents() {
        Array.from(document.querySelectorAll(this.triggerClass)).forEach((el) => {
            el.addEventListener('click', () => {
                const eventCategory = el.getAttribute('data-category');
                const salesman = el.getAttribute('data-salesman');
                if ('ga' in window) {
                    const tracker = ga.getAll()[0]; // eslint-disable-line
                    if (tracker) {
                        tracker.send({
                            hitType: 'event',
                            eventCategory,
                            eventAction: 'click',
                            eventLabel: salesman,
                        });
                    }
                }
                // ga('send', // eslint-disable-line
                //     {
                //         hitType: 'event',
                //         eventCategory,
                //         eventAction: 'click',
                //         eventLabel: salesman,
                //     });
            });
        });
    }
}

export default GaEvents;
